import { getStoredSessionToken, clearSessionToken } from './sessionUtils';
import { t } from 'i18next';

const HEARTBEAT_INTERVAL = process.env.NEXT_PUBLIC_HEARTBEAT_INTERVAL
  ? Number(process.env.NEXT_PUBLIC_HEARTBEAT_INTERVAL)
  : 20000;
let currentIntervalId = null;
let lastHeartbeatTime = null;
let isSessionExpired = false;
let isHeartbeatInFlight = false;
let modalCallback = null;

export const setModalCallback = (callback) => {
  modalCallback = callback;
};

const checkSessionStatus = async (subdomain) => {
  if (isSessionExpired || isHeartbeatInFlight) {
    return false;
  }

  isHeartbeatInFlight = true;
  lastHeartbeatTime = Date.now();

  try {
    const sessionToken = getStoredSessionToken();
    if (!sessionToken) {
      isHeartbeatInFlight = false;
      return;
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_CHECKOUT}/mirror-core/v1/public/events/${subdomain}/sessions`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: sessionToken,
        status: 'alive'
      })
    });

    isHeartbeatInFlight = false;

    if (response.status === 401) {
      isSessionExpired = true;
      if (currentIntervalId) {
        clearInterval(currentIntervalId);
        currentIntervalId = null;
      }
      clearSessionToken();
      if (modalCallback) {
        modalCallback('INVALID_SESSION_TOKEN');
      }
      return false;
    }

    if (!response.ok) {
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error sending heartbeat:', error);
    isHeartbeatInFlight = false;
    return false;
  }
};

export const startHeartbeat = (subdomain) => {
  if (currentIntervalId) {
    return () => {};
  }

  isSessionExpired = false;
  isHeartbeatInFlight = false;

  const handleFocus = async () => {
    if (!isSessionExpired && (!lastHeartbeatTime || Date.now() - lastHeartbeatTime > HEARTBEAT_INTERVAL)) {
      await checkSessionStatus(subdomain);
    }
  };

  const handleVisibilityChange = async () => {
    if (!isSessionExpired && document.visibilityState === 'visible') {
      const timeSinceLastHeartbeat = lastHeartbeatTime ? Date.now() - lastHeartbeatTime : Infinity;
      if (!lastHeartbeatTime || timeSinceLastHeartbeat > HEARTBEAT_INTERVAL) {
        await checkSessionStatus(subdomain);
      }
    }
  };

  window.addEventListener('focus', handleFocus);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  checkSessionStatus(subdomain);

  currentIntervalId = setInterval(() => {
    checkSessionStatus(subdomain);
  }, HEARTBEAT_INTERVAL);

  return () => {
    if (currentIntervalId) {
      clearInterval(currentIntervalId);
      currentIntervalId = null;
    }
    isHeartbeatInFlight = false;
    window.removeEventListener('focus', handleFocus);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
}; 